module.exports = __webpack_public_path__ + "68a8bd41e6fc85aeff491fb0029af511.svg";